export function isObjectEmpty(obj: Object) {
	return Object.entries(obj).length === 0;
}
